import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthStore } from '../../core/auth/services/auth.store';
import { Router } from '@angular/router';
import { isEmail, isEmpty } from '../../shared/helpers/utils.helpers';
import { TranslateService } from 'src/app/shared/services/translate.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { APP_CONFIG } from '../../app.config';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit, OnDestroy {
  isAuthorized: boolean;
  private ngUnsubscribe$: Subject<undefined> = new Subject();
  public env = { ...APP_CONFIG };

  constructor(public authStore: AuthStore, private router: Router, public translator: TranslateService) {}

  ngOnInit() {
    this.authStore.resetState();
    if (this.authStore.state.isLoggedIn) {
      this.router.navigateByUrl(this.authStore.state.redirectUrl);
    }

    this.isAuthorized = true;
    this.authStore.state$.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((state) => {
      if (state.requests.getAccountInfo.error) {
        this.isAuthorized = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  hideAlert() {
    this.authStore.state.requests.getAccountInfo.error = false;
    this.authStore.state.requests.requestForToken.error = false;
  }

  login(email: string, password: string) {
    if (this.authStore.state.requests.requestForToken.inProgress !== true) {
      this.authStore.requestForToken(email, password);
    }
  }
}
